import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { getMenuName } from 'app/implementation/shared/services/common-method';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { DwRouteInfoService } from '@webdpt/framework';
@Component({
  selector: 'app-custom-info',
  template: `
<div id="customcontent" class="record-content" (click)="salescustomcloseOpenWin($event)">
	<div id="salescustom"  class="record-custom">
            <div class="record-title">
                   <div class="record-titlename">客户记录</div>
				   <a class="record-titleicon2" [hidden]="showType" (click)="changeshowType($event)"><img class="operate-img" src="./assets/img/home/图标排列.png"></a>
				   <a class="record-titleicon2" [hidden]="!showType" (click)="changeshowType($event)"><img class="operate-img" src="./assets/img/home/列表.png"></a>  
				   <a class="record-titleicon1" [hidden]="!ifAmplify" (click)="changeifAmplify($event)"><img class="operate-img" src="./assets/img/home/放大.png"></a>
				   <a class="record-titleicon1" [hidden]="ifAmplify" (click)="changeifAmplify($event)"><img class="operate-img" src="./assets/img/home/缩小.png"></a>
				   <a class="record-titleicon" (click)="salescustomcloseOpenWin2($event)"><i style="color: #697081;" class="anticon anticon-close"></i></a>
			</div>
			<div class="record-list">
			<a [ngClass]="showScreenClass ? 'showScreenClass1' : 'showScreenClass2'" class="record-shaixuan" (click)="showScreen()"><i class="anticon anticon-filter"    style="margin-right: 1px;"></i> 筛选</a>
                    <div  *ngIf="ifshowScreen" class="record-select">
						  <div class="fx_form_group">
							<div dw-row dwGutter="8">
								<div dw-col dwXs="22" dwMd="22" dwLg="22" dwXl="22" style="margin-top: 10px;">
									<div style="display: flex;height: 80px;">
										<div style="color: #333333;font-size: 13px;width: 100px;text-align: right;">
										   类型：
										</div>

										<div style="display: flex;width: 270px;flex-wrap: wrap;">
                                            <a [ngClass]="val.ischeck ? 'screen_type2' : 'screen_type'" *ngFor="let val of screenTypeList" (click)="checkScreenType(val)">
                                               {{val.aaa002_n1}}
										     </a>
										</div>
                                    </div>

									<dw-form-control  style="margin-left: -4px;margin-right: -4px;">
										<dw-form-range-picker [(ngModel)]="screenDate" dwLabel="日期"
										  [dwPlaceHolder]="['开始日期','结束日期']">
										</dw-form-range-picker>
									  </dw-form-control>
								</div>
							</div>
				
						</div>
						 <a class="record-confirm" (click)="confirmScreen()">确定</a>
					</div>

				<dw-timeline dwMode="custom" *ngIf="showType && ifAmplify">
					<dw-timeline-item *ngFor="let obj of Traces2" dwPosition="left">
						<div class="record-selectlist">
							<span class="fx_timeline_title">{{obj.time}} </span>
							<div *ngFor="let val of obj.detail_list" class="record-selectcontent">
								<span class="fx_timeline_title" class="record-imgtitle"><img  class="record-img" src={{val.url}}>{{val.title}} </span>
								<div *ngIf="val.name != null" class="record-name">{{val.name}}</div>
								<div style="margin-top: 5px;">
								<div class="fx_timeline_list" *ngFor="let val2 of val.detail_list2;let i = index">
									<div style="display: flex;" (click)="jumpScreen2(i,val2.value,val.title)">
										<div class="record-lable">{{val2.label}}:</div>
										<a class="record-value">{{val2.value}}</a>
									</div>
								</div>
								</div>
							</div>
						</div>
					</dw-timeline-item>
				</dw-timeline>

				<dw-timeline dwMode="custom" *ngIf="showType && !ifAmplify">
					<dw-timeline-item *ngFor="let obj of Traces2" dwPosition="left">
						<div class="record-selectlist">
							<span class="fx_timeline_title">{{obj.time}} </span>
							<div  style="display: flex;flex-wrap: wrap;">
							<div *ngFor="let val of obj.detail_list" class="record-selectcontent2">
								<span class="fx_timeline_title" class="record-imgtitle"><img  class="record-img" src={{val.url}}>{{val.title}} </span>
								<div *ngIf="val.name != null" class="record-name">{{val.name}}</div>
								<div style="margin-top: 5px;">
								<div class="fx_timeline_list" *ngFor="let val2 of val.detail_list2;let i = index">
									<div style="display: flex;" (click)="jumpScreen2(i,val2.value,val.title)">
										<div class="record-lable">{{val2.label}}:</div>
										<a class="record-value">{{val2.value}}</a>
									</div>
								</div>
							  </div>
							</div>
							</div>
						</div>
					</dw-timeline-item>
				</dw-timeline>

				<table *ngIf="!showType">
					<thead>
						<tr>
						<th style="width: 10%;">日期</th>
						<th style="max-width: 10%;min-width: 70px;">人员</th>
						<th style="max-width: 10%;min-width: 50px;">类型</th>
						<th style="width: 10%;">单号</th>
						<th style="width: 10%;">内容</th>
						<th style="width: 50%;">说明</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let val of Traces1">
						<td>{{val.time2}}</td>
						<td>{{val.name}}</td>
						<td>{{val.title}}</td>
						<td style="color:#1890FF"><a (click)="jumpScreen(val.value1,val.title)">{{val.value1}}</a></td>
						<td>{{val.content}}</td>
						<td>{{val.note}}</td>
						</tr>
					</tbody>
				</table>
			</div>
	</div>
</div>
  `,
  styles: [`
  .record-content{
    top: 0px;left: 0px;height: 100%;width: 100%;position: absolute;z-index: 1000;display: none;
  }
  .record-content .record-custom{
    position: absolute;
	width: 400px;
	height: 80%;
	background-color: #ffffff;
	border-radius: 6px;box-shadow: 0px 0px 10px 0px rgba(79, 90, 103, 0.4);
  }
  .record-content .record-title{
    width: 100%;height: 50px;position: relative;border-bottom:1px solid #EEEFF1;
  }
  .record-content .record-titlename{
    font-size: 15px;color: #333333;font-weight: 500;display: flex;align-items:center;margin-left: 16px;height: 50px;
  }
  .record-content .record-titleicon{
    position: absolute;right: 17px;top: 0px;font-size: 20px;height: 50px;display: flex;align-items:center;
  }
  .record-content .record-titleicon1{
    position: absolute;right: 50px;top: 0px;font-size: 20px;height: 50px;display: flex;align-items:center;
  }
  .record-content .record-titleicon2{
    position: absolute;right: 80px;top: 0px;font-size: 20px;height: 50px;display: flex;align-items:center;
  }
  .record-content .record-list{
    margin-top: 10px;padding: 0px 7px;font-size: 14px;
	height: calc(100% - 80px);
	overflow-y: scroll;
  }
  .record-content .record-shaixuan{
    z-index: 998;position: absolute;top:55px;right: 25px;
  }
  .record-content .record-select{
    z-index: 999;position: absolute;top:85px;right: 0px;width: 400px;height: 200px;background-color: #ffffff;border-radius: 6px;box-shadow: 0px 0px 8px 0px rgba(79, 90, 103, 0.3);
  }
  .record-content .record-confirm{
    display: flex;
	justify-content: center;
	align-items: center;background-color: #3BA7FF;width: 60px;
	height: 32px;
	border-radius: 4px;color:#FFFFFF;position: absolute;bottom: 10px;right: 10px;
  }
  .record-content .record-selectlist{
    width: 100%;padding: 0px 5px 5px 5px;letter-spacing: 0.5px;
  }
  .record-content .record-selectcontent{
    position: relative;background-color: #F8F9FC;border-radius: 6px;padding: 5px;width: 318px;margin-top: 5px;padding:8px 14px;
  }
  .record-content .record-selectcontent2{
    position: relative;background-color: #F8F9FC;border-radius: 6px;padding: 5px;width: 400px;margin-top: 5px;padding:8px 14px;margin-left: 20px;
  }
  .record-content .record-imgtitle{
    display: flex;align-items:center;color: #4F5A67;
  }
  .record-content .record-img{
    width: 14px;height: 14px;margin-right: 6px;
  }
  .record-content .operate-img{
    width: 14px;height: 14px;
  }
  .record-content .record-name{
    position: absolute;right: 10px;font-size: 13px;top: 8px;color: #4F5A67;
	height: 20px;
	border-radius: 8px;display: flex;align-items:center;justify-content:center;
    background: #E2EBFF;
    padding: 10px 10px;
  }
  .record-content .record-lable{
    color: #8A95A3;white-space: nowrap;width: 70px;
  }
  .record-content .record-value{
    color: #111111;
	width: 200px;
  }
	.record-content .ant-timeline{
	padding: 1px;
	}
	.record-content .screen_type{
		width: 48px;
		height: 26px;
		border-radius: 16px;
		background: #FFFFFF;
		box-sizing: border-box;
		border: 1px solid #E4E4E5;
		color: #9CA0AC;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		margin-left: 5px;
	}
	.record-content .screen_type2{
		width: 48px;
		height: 26px;
		border-radius: 16px;
		background: #FFFFFF;
		box-sizing: border-box;
		border: 1px solid #3BA7FF;
		color: #3BA7FF;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		margin-left: 5px;
	}
		.record-content table {
			border: 1px solid #E4E4E5;
			border-collapse: collapse;
			width: 100%;
			margin-top: 20px;
			border-radius: 2px 2px 0px 0px;
			font-size: 14px;
		}
		.record-content td {
			border: 1px solid #E4E4E5; 
			padding: 10px;
			height: 44px;
		}
		.record-content th {
			border: 1px solid #E4E4E5; 
			padding: 10px;
			background: #EFF3FF;
			height: 44px;
		}
		.record-content .showScreenClass1{
           color:#3BA7FF
			}
		.record-content .showScreenClass2{
		color:#8A95A3
			}
  `],
  encapsulation: ViewEncapsulation.None
})
export class CustomComponent implements OnInit {
	public ifAmplify = true; //true缩小 false放大
	public showType = true; //true时间线 false表格
	public ifshowScreen = false;
	public showScreenClass = false;
	public screenDate: string = "";
	public screenType: string = "";
	public screenTypeList=[];
	public daecust: string = "";
	public Traces2 = [];
	public Traces1 = [];
	public optionsscreenType$: Observable<any>;
	constructor(
		public http: FxDapHttpClient,
		private dwRouteInfoService: DwRouteInfoService,
		private fxUserService: FxUserInfoService,
	) {
       }

  ngOnInit(): void {
    //获取初始数据
	this.optionsscreenType$ = this.fxUserService.getSysEnumById$('1020');
	this.optionsscreenType$.forEach(datas => {
		this.screenTypeList=datas
	  });
	  this.screenTypeList.forEach(data => {
		data.ischeck=false
	  });
  }
  visible: boolean;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
    console.log(value);
  }

  public salescustomcloseOpenWin($event){
	var div2 = document.getElementById('customcontent');
	var div = document.getElementById('salescustom');
	if (!div.contains($event.target)) {
	  div2.style.display = 'none';
	}
  }
  
    public salescustomcloseOpenWin2($event){
	  var div2 = document.getElementById('customcontent');
	  div2.style.display = 'none';
    }

	public changeshowType($event){
		this.showType=!this.showType
		var div = document.getElementById('salescustom');
		if(this.ifAmplify&&!this.showType){
			div.style.width = '600px';
		}else if(this.ifAmplify&&this.showType){
			div.style.width = '400px';
		}
	}

	public changeifAmplify($event){
		this.ifAmplify=!this.ifAmplify
		var div = document.getElementById('salescustom');
		if(this.ifAmplify&&!this.showType){
			div.style.width = '600px';
		}else if(this.ifAmplify&&this.showType){
			div.style.width = '400px';
		}else{
			div.style.width = '1470px';
		}
	}
	
	public showScreen(){
	   this.ifshowScreen=!this.ifshowScreen
	}

	public checkScreenType(val){
		val.ischeck=!val.ischeck;
	 }
  
	public confirmScreen(){
      this.showScreenClass=false;
	  let param={};
	  let screenTypeList=[]
	  this.screenTypeList.forEach(data => {
			if(data.ischeck){
				screenTypeList.push(data.aaa002)
				this.showScreenClass=true;
			}
	  });
	  if(this.screenDate.length!=2){
		 param={daecust:this.daecust,screenTypeList:screenTypeList};
	  }else{
		this.showScreenClass=true;
		 param={daecust:this.daecust,startTime:moment(this.screenDate[0]).format('YYYY/MM/DD').toString(),endTime:moment(this.screenDate[1]).format('YYYY/MM/DD').toString(),screenTypeList:screenTypeList};
	  }
	this.http.post<any>('D/IFxdi111Service/getCustomerRecords', { param: param}).subscribe(response => {
		 if(response.success){
		  this.Traces2=response.data.Traces2
		  this.Traces1=response.data.Traces1
		  this.ifshowScreen=!this.ifshowScreen
		 }
	  });
   }

   public  getCustomerRecords(param){
	    this.daecust=param.daecust;
		this.http.post<any>('D/IFxdi111Service/getCustomerRecords', { param: param}).subscribe(response => {
		if(response.success){
		var div2 = document.getElementById('customcontent');
		var div = document.getElementById('salescustom');
		div2.style.display = 'block';
		div.style.right = '10px';
		div.style.bottom = '65px';
		this.Traces2=response.data.Traces2
		this.Traces1=response.data.Traces1
		}
	});
   }

   public jumpScreen(value,name){
    switch (name) {
	    case "项目":
		this.detailTab('fxdi300','/fxdi300','dda001',value);
		break;
		case "跟进":
		this.detailTab('fxdd025','/fxdd025/fxdd025-s02','daudocno',value);
		break;
		case "报价":
		this.detailTab('fxdd003','/fxdd003/fxdd003-s02','dbgdocno',value);
		break;
		case "合同":
		this.detailTab('fxdd008','/fxdd008/fxdd008-s02','ddbdocno',value);
		break;
		case "订单":
		this.detailTab('fxed006','/fxed006/fxed006-s02','eaadocno',value);
		break;
        case "出货":
        this.detailTab('fxed011','/fxed011','ebadocno',value);
        break;
        case "回款":
		this.detailTab('fxgd100','/fxgd100/fxgd100-s02','gcadocno',value);
        break;
        case "开票":
        this.detailTab('fxgd101','/fxgd101/fxgd101-s02','gcddocno',value);
        break;
	    case "退货":
		this.detailTab('fxed012','/fxed012','ecadocno',value);
        break;
        case "售后":
		this.detailTab('fxdd056','/fxdd056/fxdd056-s02','deudocno',value);
        break;
      }
  }

  public jumpScreen2(index,value,name){
	if(index!=0){
		return;
	  }
      switch (name) {
	    case "项目":
		this.detailTab('fxdi300','/fxdi300','dda001',value);
		break;
		case "跟进":
		this.detailTab('fxdd025','/fxdd025/fxdd025-s02','daudocno',value);
		break;
		case "报价":
		this.detailTab('fxdd003','/fxdd003/fxdd003-s02','dbgdocno',value);
		break;
		case "合同":
		this.detailTab('fxdd008','/fxdd008/fxdd008-s02','ddbdocno',value);
		break;
		case "订单":
		this.detailTab('fxed006','/fxed006/fxed006-s02','eaadocno',value);
		break;
        case "出货":
        this.detailTab('fxed011','/fxed011','ebadocno',value);
        break;
        case "回款":
		this.detailTab('fxgd100','/fxgd100/fxgd100-s02','gcadocno',value);
        break;
        case "开票":
        this.detailTab('fxgd101','/fxgd101/fxgd101-s02','gcddocno',value);
        break;
	    case "退货":
		this.detailTab('fxed012','/fxed012','ecadocno',value);
        break;
        case "售后":
		this.detailTab('fxdd056','/fxdd056/fxdd056-s02','deudocno',value);
        break;
      }
  }

     // 页签点击单号跳转对应作业
	 async detailTab(programId:string, routerLink:string,docnoKey:string, event): Promise<any> {
		// 详情在新页签打开
		let routeParams = {
			id: programId,
			menuId: getMenuName(programId),
			name: '',
			routerLink: routerLink,
			queryParams: { [docnoKey]: event, xState: 'browse' }
		  }
		if('fxdd008'==programId){
			routeParams = {
				id: programId,
				menuId: getMenuName(programId),
				name: '',
				routerLink: routerLink,
				queryParams: { [docnoKey]: event, xState: 'browse','ddbver': 1 }
			  }
		}
		this.dwRouteInfoService.create(routeParams);
	  }
	
}